module.exports = __webpack_public_path__ + "static/media/Building A-1-Meter_MDB.ee61acfa.jpg";